"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TealiumContactInfoBoxData = void 0;
const trackingActions_1 = require("./trackingActions");
const getEventCategoryData = (pageName) => ({
    eventCategory: pageName ?? trackingActions_1.PAGE_NAME_CONTACT_INFO,
});
exports.TealiumContactInfoBoxData = {
    [trackingActions_1.CONTACT_INFO_BUTTON_CALL_US]: ({ pageName }) => ({
        ...getEventCategoryData(pageName),
        action: trackingActions_1.TealiumAction.CLICK,
        format: trackingActions_1.TealiumFormat.BUTTON,
        component: trackingActions_1.TealiumComponent.CONTACT_INFO,
        element: 'phoneNumber',
        eventLabel: 'telephoneButton',
        eventAction: trackingActions_1.TealiumEventAction.CLICK_BUTTON,
    }),
    [trackingActions_1.CONTACT_INFO_MODAL_TD]: ({ pageName }) => ({
        ...getEventCategoryData(pageName),
        action: trackingActions_1.TealiumAction.OPEN,
        format: trackingActions_1.TealiumFormat.MODAL,
        element: 'full',
        component: trackingActions_1.TealiumComponent.CONTACT_INFO_MODALTD,
        eventAction: trackingActions_1.TealiumEventAction.MODAL_SECURITY,
        eventLabel: 'openModal',
    }),
    [trackingActions_1.CONTACT_INFO_MODAL_TD_BUTTON_PRIMARY]: ({ pageName }) => ({
        ...getEventCategoryData(pageName),
        action: trackingActions_1.TealiumAction.CONTINUE,
        format: trackingActions_1.TealiumFormat.BUTTON,
        element: 'understood',
        component: trackingActions_1.TealiumComponent.CONTACT_INFO_MODALTD,
        eventAction: trackingActions_1.TealiumEventAction.CLICK_LINK,
        eventLabel: 'continueLink',
    }),
    [trackingActions_1.CONTACT_INFO_MODAL_TD_LINK_CLOSE]: ({ pageName }) => ({
        ...getEventCategoryData(pageName),
        action: trackingActions_1.TealiumAction.CLOSE,
        format: trackingActions_1.TealiumFormat.LINK,
        element: 'close',
        component: trackingActions_1.TealiumComponent.CONTACT_INFO_MODALTD,
        eventAction: trackingActions_1.TealiumEventAction.CLICK_LINK,
        eventLabel: 'closeLink',
    }),
};
//# sourceMappingURL=tealium.js.map